import React, { useEffect, useState } from 'react';

import { Calendar, ShareFacebook, ShareLinkedin, ShareWhatsapp } from '../../../../assets/img/svg/icons';

const ContentSection: React.FC<{post: any}> = ({post}) => {
    const [currentUrl, setCurrentUrl] = useState<string | null>(null);

    useEffect(() => {
        setCurrentUrl(window.location.href);
    }, []);

    return (
        <section className='pt-4 pb-12 md:-mt-8'>
            <div className="max-w-screen-lg mx-auto px-4">
                <div className="flex flex-col justify-center font-semibold text-sm items-center text-main-pink pt-4 md:pt-0">
                    <Calendar className='mb-1' />
                    {post.data.toLocaleDateString('pt-br', { day: '2-digit', month: '2-digit', year: '2-digit' }).replace(/\//g, '.')}
                </div>

                <h2 className='font-semibold text-xl md:text-2xl text-center text-balance'>
                    {post.titulo}
                </h2>

                <div className="rounded-xl h-[250px] md:h-[450px] overflow-hidden mt-8">
                    <img src={post.thumbnail} alt="Thumbnail" className='w-full h-full object-cover' />
                </div>

                <div className="mt-8 text-justify text-sm 2xl:text-base" dangerouslySetInnerHTML={{ __html: post.content }} />

                <div className="flex gap-x-8 items-center flex-col md:flex-row">
                    <div className="flex items-center gap-6 mt-10">
                        <span className='font-semibold text-sm'>Compartilhe</span>

                        <div className="flex items-center gap-4">
                            <a href={`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`} title='Facebook' target='_blank' className='transition-all duration-200 hover:scale-110'>
                                <ShareFacebook className='w-8 h-8 object-contain' />
                            </a>

                            <a href={`https://api.whatsapp.com/send?text=${currentUrl}`} title='Whatsapp' target='_blank' className='transition-all duration-200 hover:scale-110'>
                                <ShareWhatsapp className='w-8 h-8 object-contain' />
                            </a>

                            <a href={`https://www.linkedin.com/shareArticle?mini=true&url=${currentUrl}&title=${post.slug}`} title='Linkedin' target='_blank' className='transition-all duration-200 hover:scale-110'>
                                <ShareLinkedin className='w-8 h-8 object-contain' />
                            </a>
                        </div>
                    </div>

                    <section className='py-8 mt-4 relative z-10'>
                        <div className="mx-auto py-8 px-8 md:px-14 bg-light-yellow rounded-3xl grid md:grid-cols-3 gap-4 items-center relative before:content-[''] before:h-full before:w-[95%] before:left-1/2 before:-translate-x-1/2 before:bg-main-blue/50 before:rounded-3xl before:absolute md:before:-rotate-2 before:-rotate-3 before:-z-10">
                            <h3 className="font-semibold text-xl md:text-2xl text-balance md:col-span-2">
                                Siga nosso instagram e acompanhe as novidades. 
                            </h3>

                            <div className="flex justify-center items-center">
                                <a href="https://www.instagram.com/uniexpo_oficial/" target='_blank' className='uppercase bg-main-pink text-white text-center font-semibold rounded-full p-2 w-full transition-all duration-200 ease-in-out hover:bg-main-blue'>
                                    Seguir
                                </a>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </section>
    );
};

export default ContentSection;